import { getReportList, ReportByProcedureId, PdfPrintTemplateList, GetLock, saveReports, hospitalTemplate,
  templateInfo, saveModule, deleteUserReportTemplate, stateRecord, historyReport, GetTableHeaderConfigs, GetDiagnosticDeparts, AddDiagnosticAllocation,
  RollBackAllocation, NewReport, StatusRejectedToDiagnosing, SubmitReport, DeleteReport, AbandonApproveReport, RejectReport, SubmitApproveReport, RecallReport, AutoSaveReport,
  BeginApproveReport, DeletePerform, getLatestDispatchedProcedure, getLatestFinishedReport } from '@/api/diagnostic'
import { formatDate } from '@/utils/index.js'
const diagnostic = {
  state: {
    totalCount: 0,
    list: [],
    printInfo: {
      age: '',
      applyDepart: '',
      applyDoctor: '',
      bedNo: '',
      bodyParts: '',
      checkingItems: '',
      creater: '',
      createrName: '',
      departId: '',
      endExecDt: '',
      examinDt: '',
      firstApprover: '',
      firstApproverName: '',
      healthHistory: '',
      inpatientNo: '',
      isEmergency: 0,
      isPositive: 0,
      isPositiveName: '',
      modality: 0,
      modalityName: '',
      patientId: '',
      patientName: '',
      patientNo: '',
      patientType: '',
      performId: '',
      performNo: '',
      procedureId: '',
      procedureIds: [],
      regDt: '',
      regId: '',
      regNo: '',
      register: '',
      reportId: '',
      sex: 1,
      sexName: '',
      status: 50,
      statusName: '',
      studyUid: '',
      submitTime: '',
      submitterName: '',
      weasisPacsUrl: '',
      webPacsUrl: '',
      wyg: '',
      wys: ''
    },
    templates: [],
    RecordList: '',
    RecordPatient: '',
    patientReportList: [],
    patientInfo: '',
    ReportVariable: {
      procedureId: '',
      type: ''
    },
    lock: false,
    printList: [],
    headerList: [],
    DiaDeparts: [],
    searchReport: {
      Status: 0,
      patientName: '',
      patientNo: '',
      RegNo: '',
      PerformId: '',
      PatientType: '',
      SubmitterName: '',
      DateArray: [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')],
      Modality: '',
      bodyPart: '',
      DepartId: '',
      PageIndex: 1,
      PageCount: 10,
      CompleteStatus: 0,
      IsShowAll: 1,
      SendTypes: [0, 1, 2],
      SrcHospitalName: ''
    },
    search: {
      Status: 0,
      patientName: '',
      patientNo: '',
      RegNo: '',
      PerformId: '',
      PatientType: '',
      SubmitterName: '',
      DateArray: [new Date(), new Date()],
      Modality: '',
      bodyPart: '',
      DepartId: '',
      PageIndex: 1,
      PageCount: 10,
      CompleteStatus: 50,
      IsShowAll: 1,
      SendTypes: [0, 1, 2],
      SrcHospitalName: ''
    }
  },

  mutations: {
    SET_COUNT: (state, totalCount) => {
      state.totalCount = totalCount
    },
    SET_LIST: (state, list) => {
      state.list = list
    },
    SET_INFO: (state, printInfo) => {
      state.printInfo = printInfo
      // 前后端的阴阳性字段阴性值转化
      if (printInfo.isPositive === 2) {
        state.printInfo.isPositive = 0
      }
    },
    SET_SAVEMODULE: (state, datas) => {
      state.savemodulestatus = datas
    },

    SET_TEMPLATE: (state, templates) => {
      state.templates = templates
    },
    SET_TEMPLATEINFO: (state, datas) => {
      if (datas.iswordBar === '1') {
        state.printInfo.wys = datas.templates.wys
        state.printInfo.wyg = datas.templates.wyg
        // state.printInfo.isPositive = datas.templates.isPositive
      } else {
        if (state.printInfo.wys !== '') {
          state.printInfo.wys = state.printInfo.wys + datas.templates.wys
        } else {
          state.printInfo.wys = '' + datas.templates.wys
        }
        if (state.printInfo.wyg !== '') {
          state.printInfo.wyg = state.printInfo.wyg + datas.templates.wyg
        } else {
          state.printInfo.wyg = '' + datas.templates.wyg
        }
        // state.printInfo.isPositive = datas.templates.isPositive
      }
    },
    SET_RECORDLIST: (state, datas) => {
      state.RecordList = datas
    },
    SET_RECORDPATIENT: (state, datas) => {
      state.RecordPatient = datas
    },
    SET_HISTORYLIST: (state, datas) => {
      state.patientReportList = datas
    },
    SET_PATIENTINFO: (state, datas) => {
      state.patientInfo = datas
    },
    SET_REPORTVAR: (state, datas) => {
      state.ReportVariable = datas
    },
    SET_LOCK: (state, datas) => {
      state.lock = datas
    },
    SET_PRINTLIST: (state, datas) => {
      state.printList = datas
    },
    SET_HEADLIST: (state, datas) => {
      state.headerList = datas
    },
    SET_DIADEPARTS: (state, datas) => {
      state.DiaDeparts = datas
    },
    SET_SEARCHREPORT: (state, datas) => {
      state.searchReport = datas
    },
    SET_SEARCH: (state, datas) => {
      state.search = datas
    }
  },

  actions: {
    // 获取写报告列表
    GetSearchReport({ commit }, datas) {
      commit('SET_SEARCHREPORT', datas)
    },
    GetSearch({ commit }, datas) {
      commit('SET_SEARCH', datas)
    },
    DeletePerform({ commit }, params) {
      return new Promise((resolve, reject) => {
        DeletePerform(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetReportList({ commit }, search) {
      return new Promise((resolve, reject) => {
        getReportList(search).then(response => {
          const data = response.data
          commit('SET_COUNT', data.totalCount)
          if (data.reportList) {
            commit('SET_LIST', data.reportList)
          } else {
            commit('SET_LIST', [])
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetLatestDispatchedProcedure({ commit }) {
      return new Promise((resolve, reject) => {
        getLatestDispatchedProcedure().then(response => {
          const data = response.data
          // if (data.latestDispatchedProcedure) {
          //   commit('SET_LATESTDISPATCHEDPROCEDURE', data.latestDispatchedProcedure)
          // }
          // resolve()
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetLatestFinishedReport({ commit }) {
      return new Promise((resolve, reject) => {
        getLatestFinishedReport().then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetTableHeaderConfigs({ commit }, datas) {
      return new Promise((resolve, reject) => {
        GetTableHeaderConfigs(datas).then(response => {
          const data = response.data
          commit('SET_HEADLIST', data.tableHeader)
          resolve()
        }).catch(error => {
          commit('SET_HEADLIST', '')
          reject(error)
        })
      })
    },
    // 获取打印信息
    GetReportByProcedureId({ commit }, ProcedureId) {
      return new Promise((resolve, reject) => {
        ReportByProcedureId(ProcedureId).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          commit('SET_INFO', '')
          reject(error)
        })
      })
    },

    // 保存报告
    PostReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        saveReports(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 创建报告
    NewReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        NewReport(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    StatusRejectedToDiagnosing({ commit }, params) { // 已驳回状态变更为诊断中
      return new Promise((resolve, reject) => {
        StatusRejectedToDiagnosing(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    BeginApproveReport({ commit }, params) { // 创建审核
      return new Promise((resolve, reject) => {
        BeginApproveReport(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 提交诊断
    SubmitReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        SubmitReport(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 放弃诊断
    DeleteReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        DeleteReport(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 放弃审核
    AbandonApproveReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        AbandonApproveReport(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 驳回报告
    RejectReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        RejectReport(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 审核/提交诊断并审核
    SubmitApproveReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        SubmitApproveReport(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 审核召回报告
    RecallReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        RecallReport(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 自动保存
    AutoSaveReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        AutoSaveReport(params).then(response => {
          const data = response.data
          commit('SET_INFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存个人模板
    PostModule({ commit, state }, params) {
      params.checkItemID = state.printInfo.checkItemID
      params.bodyPartsID = state.printInfo.bodyPartsID
      params.userID = state.printInfo.userID
      params.hospitalId = state.printInfo.hospitalId
      params.wysText = state.printInfo.wysText
      params.wygText = state.printInfo.wygText
      params.Sex = state.printInfo.Sex
      params.isPositive = state.printInfo.isPositive
      params.deviceTypeID = state.printInfo.deviceTypeID
      return new Promise((resolve, reject) => {
        saveModule(params).then(response => {
          const data = response.data
          commit('SET_SAVEMODULE', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取模板
    getTemplate({ commit }, datas) {
      return new Promise((resolve, reject) => {
        hospitalTemplate(datas).then(response => {
          const data = response.data
          commit('SET_TEMPLATE', data.templateList)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 模板详情
    getTemplateInfo({ commit }, datas) {
      return new Promise((resolve, reject) => {
        templateInfo(datas.dircId).then(response => {
          const data = response.data
          commit('SET_TEMPLATEINFO', { templates: data, iswordBar: datas.wordBar })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除个人报告模板
    deleteUserReportTemplate({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteUserReportTemplate(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取状态记录
    getstateRecord({ commit }, id) {
      return new Promise((resolve, reject) => {
        stateRecord(id).then(response => {
          const data = response.data
          commit('SET_RECORDLIST', data.historyList)
          commit('SET_RECORDPATIENT', data.patient)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取历史报告
    gethistoryReport({ commit }, id) {
      return new Promise((resolve, reject) => {
        historyReport(id).then(response => {
          const data = response.data
          commit('SET_HISTORYLIST', data.reportList)
          commit('SET_PATIENTINFO', data.patient)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 写报告所需中间变量
    getReportVariable({ commit }) {
      var datas = JSON.parse(sessionStorage.getItem('setReportVariable'))
      commit('SET_REPORTVAR', datas)
    },

    // 获取报告是否被锁
    getLock({ commit }, id) {
      return new Promise((resolve, reject) => {
        GetLock(id).then(response => {
          const data = response
          commit('SET_LOCK', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取打印模板列表
    getPdfPrintTemplateList({ commit }) {
      return new Promise((resolve, reject) => {
        PdfPrintTemplateList().then(response => {
          const data = response.data
          if (data.pdfPrintTemplateList.length > 0) {
            commit('SET_PRINTLIST', data.pdfPrintTemplateList)
          } else {
            commit('SET_PRINTLIST', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_PRINTLIST', [])
          reject(error)
        })
      })
    },
    // 获取当前科室的可分配科室
    GetDiagnosticDeparts({ commit }) {
      return new Promise((resolve, reject) => {
        GetDiagnosticDeparts().then(response => {
          const data = response.data
          if (data.departs.length > 0) {
            commit('SET_DIADEPARTS', data.departs)
          } else {
            commit('SET_DIADEPARTS', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_DIADEPARTS', [])
          reject(error)
        })
      })
    },
    // 手动分配
    AddDiagnosticAllocation({ commit }, params) {
      return new Promise((resolve, reject) => {
        AddDiagnosticAllocation(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退回
    RollBackAllocation({ commit }, params) {
      return new Promise((resolve, reject) => {
        RollBackAllocation(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 重置
    resetdiagnostic({ commit }) {
      commit('SET_COUNT', 1)
      commit('SET_LIST', [])
    }
  }
}

export default diagnostic
